/* Attendee Avatar (piece 4, decision 0055). Every measure derives from
   --avatar-size and the ratio tokens, so a row's spacing scales with the
   avatar and is never a pixel floor. */
.avatar {
  --avatar-radius: calc(var(--avatar-size) / 2);
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--avatar-size);
  height: var(--avatar-size);
  border-radius: var(--radius-stadium);
  background: var(--avatar-fill);
  color: var(--on-avatar);
  font-size: max(calc(var(--avatar-size) * var(--avatar-initials-ratio)), var(--font-size-caption));
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  letter-spacing: 0.02em;
  user-select: none;
  pointer-events: none;
}

/* The initials centre on their cap height rather than on the line box, whose ascent and descent differ by font and would sit the letters low; the tracking's trailing space is given back. */
.initials {
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  margin-right: -0.02em;
  /* Decision 1646: a wide fallback font clips at the rim and never crosses it. The pair never wraps: a parent that allows a break anywhere (the event card's notes column) would otherwise stack "M" over "A" (found while building, 2026-10-03). */
  max-width: calc(var(--avatar-size) - var(--space-1));
  overflow: hidden;
  white-space: nowrap;
  overflow-wrap: normal;
}

/* Declined greys the fill rather than fading it: a faded fill under white initials falls below 4.5:1. */
.avatar[data-attending='Declined'] {
  filter: grayscale(1);
}

.avatar[data-attending='Tentative'] {
  box-shadow: inset 0 0 0 var(--control-border-width) var(--on-avatar);
}

/* The RSVP badge: 42% of the radius, its centre on the avatar's rim at the
   lower-right diagonal (decision 1519), and the initials are sized so the badge
   clears them at every avatar size. The icon is 70% of the badge. */
.badge {
  position: absolute;
  width: calc(var(--avatar-radius) * var(--avatar-badge-ratio) * 2);
  height: calc(var(--avatar-radius) * var(--avatar-badge-ratio) * 2);
  right: calc(var(--avatar-radius) * (1 - var(--avatar-rsvp-offset-ratio) * 0.7071) - var(--avatar-radius) * var(--avatar-badge-ratio));
  bottom: calc(var(--avatar-radius) * (1 - var(--avatar-rsvp-offset-ratio) * 0.7071) - var(--avatar-radius) * var(--avatar-badge-ratio));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-stadium);
  background: var(--status-good-text);
  color: var(--on-status-fill);
  box-shadow: 0 0 0 1px var(--surface);
}

.badge svg {
  width: 70%;
  height: 70%;
}

/* Centre to centre is ratio × radius; the gap between edges is that less the
   diameter: (ratio − 2) radii. */
.row {
  display: inline-flex;
  align-items: center;
  gap: calc(var(--avatar-size) * (var(--avatar-row-spacing-ratio) - 2) / 2);
}
